import axios from "axios";
import Fingerprint2 from "fingerprintjs2";
import { get } from "lodash";
import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import * as loginAction from "~/store/login/actions";
import * as typesLogin from "~/store/login/types";
import * as notiAction from "~/store/notifications/notificationsActions";
import * as api from "~/store/user/userApi";
import * as types from "~/store/user/userType";
import { client } from "~/utils/medproSDK";
import { persistor } from "~/persist";

/* choose Profile list */
function* requestUserInfoByCode(params) {
  try {
    const response = yield call(api.apiGetUserInfoByFBCode, params.code);
    const { data } = response;
    const displayName = data.fullname ? data.fullname : data.username;
    const userInfo = { ...data, displayName }; // lưu ý: version cũ: users = displayName

    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    yield put({ type: types.GET_USER_INFO_BY_CODE_SUCCESS, userInfo });
    openToast("Bạn đã đăng nhập thành công!");
  } catch (error) {
    yield put({ type: types.GET_USER_INFO_BY_CODE_FAIL, error });
  }
}

function* watchRequestUserInfoByCode() {
  yield takeLatest(types.GET_USER_INFO_BY_CODE, requestUserInfoByCode);
}

// firebase
function* requestUserInfoByFirebaseLogin({ idToken }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const response = yield client.firebaseLogin(
      { token: idToken },
      { platform }
    );
    if (response.data.error_code) throw new Error("Lỗi server!");
    const { data } = response;
    if (!data.token) {
      throw new Error("Có lỗi xảy ra! Vui lòng đăng nhập lại!");
    }
    const displayName = data.fullname ? data.fullname : data.username;
    const userInfo = { ...data, displayName };
    yield put({ type: types.GET_USER_INFO_BY_CODE_SUCCESS, userInfo });
    openToast("Bạn đã đăng nhập thành công!");
    client.setToken(data.token);
    axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
    window.localStorage.setItem("jwt", data.token);
  } catch (error) {
    openToast(error, "error");
    yield put({ type: types.GET_USER_INFO_BY_CODE_FAIL, error });
  }
}

function* watchRequestUserInfoByFirebaseLogin() {
  yield takeLatest(types.LOGIN_BY_FIREBASE, requestUserInfoByFirebaseLogin);
}

function* requestUserInfoByZaloLogin({ code }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    // const response = yield call(api.loginByZalo, code);
    const response = yield client.zaloLogin({ code }, { platform });
    if (response.data.error_code) throw new Error("Lỗi server!");
    const { data } = response;
    if (!data.token) {
      throw new Error("Có lỗi xảy ra! Vui lòng đăng nhập lại!");
    }
    const displayName = data.fullname ? data.fullname : data.username;
    const userInfo = { ...data, displayName };
    yield put({ type: types.GET_USER_INFO_BY_CODE_SUCCESS, userInfo });
    openToast("Bạn đã đăng nhập thành công!");
    client.setToken(data.token);
    axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
    window.localStorage.setItem("jwt", data.token);
  } catch (error) {
    yield put({ type: types.GET_USER_INFO_BY_CODE_FAIL, error });
  }
}

function* watchRequestUserInfoByZaloLogin() {
  yield takeLatest(types.LOGIN_BY_ZALO, requestUserInfoByZaloLogin);
}

// login SMS
function* requestGetSMSCode({ phone }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const components = yield Fingerprint2.getPromise();
    const deviceId = Fingerprint2.x64hash128(
      components.map(component => component.value).join(""),
      31
    );
    const response = yield client.getSMSCode({ deviceId, phone }, { platform });
    const { data } = response;
    yield put({ type: types.GET_CODE_LOGIN_SMS_SUCCESS, data });
    if (!data.status) {
      throw new Error(data.message);
    }
  } catch (error) {
    openToast(error.message, "error");
  }
}

function* watchRequestUserGetSMSCode() {
  yield takeLatest(types.GET_CODE_LOGIN_SMS, requestGetSMSCode);
}

function* requestCheckSMSCode({ phone, code }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const components = yield Fingerprint2.getPromise();
    const deviceId = Fingerprint2.x64hash128(
      components.map(component => component.value).join(""),
      31
    );
    const response = yield client.checkSMSCode(
      { phone, code, deviceId },
      { platform }
    );
    const { data } = response;
    if (!data.token) {
      throw new Error("Có lỗi xảy ra! Vui lòng đăng nhập lại!");
    }
    const displayName = data.fullname ? data.fullname : data.username;
    const userInfo = { ...data, displayName };
    yield put({ type: types.GET_USER_INFO_BY_CODE_SUCCESS, userInfo });
    openToast("Bạn đã đăng nhập thành công!");
    client.setToken(data.token);
    axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
    window.localStorage.setItem("jwt", data.token);
  } catch (error) {
    // console.log(error);
    const statusCode = get(error, "response.data.statusCode");
    const message = get(error, "response.data.message");
    // console.log(statusCode);
    if (statusCode === 400) {
      openToast(message, "error");
    }
    // yield put({ type: types.GET_USER_INFO_BY_CODE_FAIL, error });
  }
}

function* watchRequestUserCheckSMSCode() {
  yield takeLatest(types.CHECK_CODE_LOGIN_SMS, requestCheckSMSCode);
}

function* requestPhoneRegisterGetSMSCode() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const components = yield Fingerprint2.getPromise();
    const deviceId = Fingerprint2.x64hash128(
      components.map(component => component.value).join(""),
      31
    );

    const flow = yield select(state => state.user.flow);
    let name = yield select(state => state.login.form.name.value);
    name = name.trim();
    name = name.replace(/ +(?= )/g, "");
    let phone = yield select(state => state.login.form.mobile.value);
    if (phone.startsWith("84")) {
      phone = phone.substring(2);
    }
    if (phone.startsWith("0")) {
      phone = phone.substring(1);
    }
    phone = `0${phone}`;

    yield put({
      type: typesLogin.CHANGE_INFO_CHECK_CODE,
      payload: { name: "", phone: "" }
    });

    const response = yield client.phoneRegisterMedproId(
      {
        fullname: name,
        deviceId,
        phone,
        // type: "password"
        type: flow
      },
      { platform }
    );
    const { data } = response;
    const otpInfo = { ...data };
    // const otpInfo = {
    //   time_left: 20,
    //   message: "Ban doi them 20 giay de gui lai",
    //   status: false
    // };
    const message = get(otpInfo, "message", null);
    const status = get(otpInfo, "status", null);

    if (message !== null) {
      openToast(message, "error");
    }
    if (status) {
      yield put({ type: typesLogin.CHANGE_STEP, payload: 3 });
    }

    yield put({ type: types.GET_CODE_REGISTER_SMS_SUCCESS, otpInfo });
    yield put({
      type: typesLogin.CHANGE_INFO_CHECK_CODE,
      payload: { name, phone }
    });
  } catch (error) {
    const statusCode = get(error, "response.data.statusCode");
    const errorMessage = get(error, "response.data.message", false);
    yield put({ type: types.GET_CODE_REGISTER_SMS_ERROR });
    if (statusCode === 400) {
      openToast(errorMessage, "error");
    }
  }
}

function* watchRequestPhoneRegisterGetSMSCode() {
  yield takeLatest(types.GET_CODE_REGISTER_SMS, requestPhoneRegisterGetSMSCode);
}

function* requestPhoneRegisterCheckSMSCode({ code }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const components = yield Fingerprint2.getPromise();
    const deviceId = Fingerprint2.x64hash128(
      components.map(component => component.value).join(""),
      31
    );

    let fullname = yield select(state => state.login.form.name.value);
    fullname = fullname.trim();
    fullname = fullname.replace(/ +(?= )/g, "");
    let phone = yield select(state => state.login.form.mobile.value);
    if (phone.startsWith("84")) {
      phone = phone.substring(2);
    }
    if (phone.startsWith("0")) {
      phone = phone.substring(1);
    }
    phone = `0${phone}`;

    const response = yield client.checkSMSCodeSignInProviderMedproId(
      {
        fullname,
        deviceId,
        phone,
        code
      },
      { platform }
    );

    const { secretKey } = response.data;
    yield put({ type: types.CHECK_CODE_REGISTER_SMS_SUCCESS, secretKey });
  } catch (error) {
    const statusCode = get(error, "response.data.statusCode");
    const message = get(error, "response.data.message");
    if (statusCode === 400) {
      yield put({ type: types.CHECK_CODE_REGISTER_SMS_ERROR });
      openToast(message, "error");
    }
  }
}
function* watchRequestPhoneRegisterCheckSMSCode() {
  yield takeLatest(
    types.CHECK_CODE_REGISTER_SMS,
    requestPhoneRegisterCheckSMSCode
  );
}

function* requestApplyPassRegisterSMSCode() {
  const type = "password";
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const secretKey = yield select(state => state.user.registerSMS.secretKey);
    let password = yield select(state => state.login.form.password.value);
    password = password.trim();
    const response = yield client.applySignInProviderMedproId(
      {
        secretKey,
        type,
        password
      },
      { platform }
    );
    const { data } = response;
    const phone = data.userName.replace("+84", "0");
    const accountRegistered = {
      ...data,
      passRegistered: password,
      phone: phone
    };
    yield put({
      type: types.APPLY_PASS_REGISTER_SMS_SUCCESS,
      accountRegistered
    });
  } catch (error) {
    const statusCode = get(error, "response.data.statusCode");
    const errorMessage = get(error, "response.data.message", false);
    yield put({ type: types.APPLY_PASS_REGISTER_SMS_ERROR });
    if (statusCode === 400) {
      openToast(errorMessage, "error");
    }
  }
}

function* watchRequestApplyPassRegisterSMSCode() {
  yield takeLatest(
    types.APPLY_PASS_REGISTER_SMS,
    requestApplyPassRegisterSMSCode
  );
}

function* requestLoginWithPassword() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    let password = yield select(state => state.login.form.password.value);
    let phone = yield select(state => state.login.form.mobile.value);
    password = password.trim();
    if (phone.startsWith("84")) {
      phone = phone.substring(2);
    }
    if (phone.startsWith("0")) {
      phone = phone.substring(1);
    }
    phone = `0${phone}`;

    const response = yield client.loginWithPasswordMedproId(
      {
        phone,
        password
      },
      { platform }
    );
    const { token, fullName, userName, email } = response.data;
    if (!token) {
      throw Error("Đã xảy ra lỗi, vui lòng đăng nhập lại !");
    }
    const userLogin = { fullName, userName, email };
    client.setToken(token);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    window.localStorage.setItem("jwt", token);

    yield put({ type: types.LOGIN_WITH_PASSWORD_SUCCESS, userLogin });
    yield put({ type: typesLogin.RESET_FIELD });

    openToast("Bạn đã đăng nhập thành công!");
  } catch (error) {
    const statusCode = get(error, "response.data.statusCode");
    const errorMessage = get(error, "response.data.message", false);
    const errorPhone = get(
      error,
      "response.data.message[0].constraints.isMobilePhone",
      false
    );
    yield put({ type: types.LOGIN_WITH_PASSWORD_ERROR });
    if (statusCode === 400) {
      if (errorMessage) openToast(errorMessage, "error");
      if (errorPhone) openToast(errorPhone, "error");
    }
  }
}
function* watchRequestLoginWithPassword() {
  yield takeLatest(types.LOGIN_WITH_PASSWORD, requestLoginWithPassword);
}

function* requestSocialRegister({ secretKey, tokenSocial }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const typeAccess = yield select(state => state.user.socialInfo.typeAccess);
    const response = yield client.applySignInProviderMedproId(
      {
        secretKey,
        type: typeAccess,
        token: tokenSocial
      },
      { platform }
    );
    const { data } = response;
    const accountRegistered = { ...data, isRegistered: true };
    yield put({ type: types.REGISTER_SOCIAL_SUCCESS, accountRegistered });
  } catch (error) {
    yield put({ type: types.REGISTER_SOCIAL_ERROR });
    openToast(error.response.data.message, "error");
  }
}

function* watchRequestSocialRegister() {
  yield takeLatest(types.REGISTER_SOCIAL, requestSocialRegister);
}

function* requestLoginWithSocial({ tokenSocial }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const typeAccess = yield select(state => state.user.socialInfo.typeAccess);
    const response = yield client.loginWithSocialMedproId(
      {
        // phone,
        type: typeAccess,
        token: tokenSocial
      },
      { platform }
    );
    const { data } = response;
    const { token, fullName, userName, email } = data;
    const requiredPhone = get(data, "requiredPhone", false);
    const socialInfo = {
      requiredPhone,
      typeAccess,
      tokenSocial
    };
    const userLogin = { fullName, userName, email };
    if (token && !requiredPhone) {
      client.setToken(token);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      window.localStorage.setItem("jwt", token);
      yield put({ type: types.LOGIN_SOCIAL_SIGNIN_SUCCESS, userLogin });
      openToast("Bạn đã đăng nhập thành công!");
    } else {
      openToast("Bạn cần liên kết tài khoản mạng xã hội với medproID", "error");
      yield put({ type: typesLogin.CHANGE_STEP, payload: 2 });
      yield put({ type: types.REQUIRE_REGISTER_SOCIAL, socialInfo });
    }
  } catch (error) {
    yield put({ type: types.LOGIN_SOCIAL_SIGNIN_ERROR });
    openToast(error.response.data.message, "error");
  }
}
function* watchRequestLoginWithSocial() {
  yield takeLatest(types.LOGIN_SOCIAL_SIGNIN, requestLoginWithSocial);
}

function* requestForgotPassword() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const components = yield Fingerprint2.getPromise();
    const deviceId = Fingerprint2.x64hash128(
      components.map(component => component.value).join(""),
      31
    );
    let phone = yield select(state => state.login.form.mobile.value);
    if (phone.startsWith("84")) {
      phone = phone.substring(2);
    }
    if (phone.startsWith("0")) {
      phone = phone.substring(1);
    }
    phone = `0${phone}`;

    const response = yield client.forgotPasswordMedproId(
      {
        phone,
        deviceId
      },
      { platform }
    );

    const { data } = response;
    const otpInfo = { ...data };

    // const otpInfo = {
    //   time_left: 20,
    //   message: "Ban doi them 20 giay de gui lai",
    //   status: false
    // };
    // show message khi false
    const message = get(otpInfo, "message", null);
    const status = get(otpInfo, "status", null);
    if (message !== null) {
      openToast(message, "error");
    }
    if (status) {
      yield put({ type: typesLogin.CHANGE_STEP, payload: 3 });
    }

    yield put({ type: types.GET_CODE_REGISTER_SMS_SUCCESS, otpInfo });
    yield put({
      type: typesLogin.CHANGE_INFO_CHECK_CODE,
      payload: { name: "", phone }
    });
  } catch (error) {
    const { statusCode } = get(error, "response.data");
    const errorMessage = get(error, "response.data.message", false);
    if (statusCode === 404) {
      if (errorMessage) openToast(errorMessage, "error");
    }
  }
}

function* watchRequestForgotPassword() {
  yield takeLatest(types.FORGOT_PASSWORD, requestForgotPassword);
}

function* requestCheckCodeForgotPassword({ code }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const components = yield Fingerprint2.getPromise();
    const deviceId = Fingerprint2.x64hash128(
      components.map(component => component.value).join(""),
      31
    );
    let phone = yield select(state => state.login.form.mobile.value);
    if (phone.startsWith("84")) {
      phone = phone.substring(2);
    }
    if (phone.startsWith("0")) {
      phone = phone.substring(1);
    }
    phone = `0${phone}`;

    const response = yield client.checkSMSCodeForgotPasswordMedproId(
      {
        phone,
        deviceId,
        code
      },
      { platform }
    );
    const { secretKey } = response.data;
    yield put({ type: types.CHECK_CODE_REGISTER_SMS_SUCCESS, secretKey });

    yield put({
      type: typesLogin.CHANGE_INFO_CHECK_CODE,
      payload: { name: response.data.user.fullname, phone }
    });
    yield put({ type: typesLogin.GET_DATA_TO_RETYPE_OTP });
  } catch (error) {
    const statusCode = get(error, "response.data.statusCode");
    const message = get(error, "response.data.message");
    if (statusCode === 400) {
      yield put({ type: types.CHECK_CODE_REGISTER_SMS_ERROR });
      openToast(message, "error");
    }
  }
}

function* watchRequestCheckCodeForgotPassword() {
  yield takeLatest(
    types.CHECK_CODE_FORGOT_PASSWORD,
    requestCheckCodeForgotPassword
  );
}

function* requestApplyNewPassword() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const secretKey = yield select(state => state.user.registerSMS.secretKey);
    let password = yield select(state => state.login.form.password.value);
    let fullname = yield select(state => state.login.form.name.value);
    fullname = fullname.trim();
    password = password.trim();
    fullname = fullname.replace(/ +(?= )/g, "");
    const response = yield client.applyNewPasswordMedproId(
      {
        fullname,
        password,
        secretKey
      },
      { platform }
    );
    const { data } = response;
    const phone = data.userName.replace("+84", "0");
    const accountRegistered = {
      ...data,
      passRegistered: password,
      phone: phone
    };
    yield put({
      type: types.APPLY_PASS_REGISTER_SMS_SUCCESS,
      accountRegistered
    });
  } catch (error) {
    const statusCode = get(error, "response.data.statusCode");
    const errorMessage = get(error, "response.data.message", "");
    yield put({ type: types.APPLY_PASS_REGISTER_SMS_ERROR });
    if (statusCode === 400) {
      openToast(errorMessage, "error");
    }
  }
}

function* watchRequestApplyNewPassword() {
  yield takeLatest(types.APPLY_PASS_FORGOT_PASSWORD, requestApplyNewPassword);
}

// Tách repo medpro id
function* loginFromMedproId({ payload }) {
  try {
    if (Object.keys(payload).length > 0 && payload.token !== "") {
      yield put({
        type: types.GET_USER_INFO_BY_CODE_SUCCESS,
        userInfo: payload
      });

      openToast("Đăng nhập thành công");
    } else {
      openToast("Đăng nhập không thành công. Vui lòng thử lại.", "error");
    }
  } catch (error) {
    console.log(error);
  }
}

function* watcherLoginFromMedproId() {
  yield takeLatest(types.LOGIN_FROM_MEDPRO_ID, loginFromMedproId);
}

// Logout
function* requestLogout() {
  yield put(loginAction.setCurrentDomain(""));
  yield put(notiAction.clearNotificationAtStore());
  persistor.purge();
}

function* watcherRequestLogout() {
  yield takeLatest(types.USER_LOG_OUT, requestLogout);
}

function* updateUserInfo({ info }) {
  try {
    yield call(api.updateUserInfo, info);

    openToast("Cập nhật thông tin thành công");
  } catch (error) {
    console.log("error :>> ", error);
    openToast("Cập nhật thông tin thất bại", "error");
  }
}

function* watcherUpdateUserInfo() {
  yield takeLatest(types.UPDATE_USER_INFO, updateUserInfo);
}

export default function* root() {
  yield all([
    fork(watchRequestUserInfoByCode),
    fork(watchRequestUserInfoByFirebaseLogin),
    fork(watchRequestUserInfoByZaloLogin),
    fork(watchRequestUserGetSMSCode),
    fork(watchRequestUserCheckSMSCode),
    fork(watchRequestPhoneRegisterGetSMSCode),
    fork(watchRequestPhoneRegisterCheckSMSCode),
    fork(watchRequestApplyPassRegisterSMSCode),
    fork(watchRequestLoginWithPassword),
    fork(watchRequestSocialRegister),
    fork(watchRequestLoginWithSocial),
    fork(watchRequestForgotPassword),
    fork(watchRequestCheckCodeForgotPassword),
    fork(watchRequestApplyNewPassword),
    fork(watcherLoginFromMedproId),
    fork(watcherRequestLogout),
    fork(watcherUpdateUserInfo)
  ]);
}
